import type { ReactNode } from "react";

import QuotaTag from "app/pages/sales-intelligence/modules/quota/components/QuotaTag";
import { formatCompactNumber } from "app/pages/sales-intelligence/utils/numbers";

import type { ConfigField, ConfigType } from "../types/columns";

type FieldBadgeRendererParams = {
    isDataCreditsEnabled: boolean;
    getFieldCost: (fieldType: ConfigType) => number | null;
};

export const createFieldBadgeComponent = ({ isDataCreditsEnabled, getFieldCost }: FieldBadgeRendererParams) => {
    return function (field: ConfigField): ReactNode {
        if (!isDataCreditsEnabled) {
            return null;
        }

        const cost = getFieldCost(field.type);

        if (cost) {
            return (
                <QuotaTag
                    size="sm"
                    type="light"
                    title={formatCompactNumber(cost)}
                />
            );
        }

        return null;
    };
};
